<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiSourceBranch } from "@mdi/js";
export default {
  name: "MdiPowerStandby",
  data() {
    return {
      svgPath: mdiSourceBranch,
    };
  },
};
</script>
